<template>
    <div class="ultralichtblauwbg padding20 margintop20">
        <span v-if="cruise.inbegrepen && cruise.inbegrepen.length > 0">
            <b>Inclusief:</b>
            <ul class="nofloat paddingleft20 nomargin margintop5">
                <li
                    v-for="(element, index) in cruise.inbegrepen"
                    :key="'CruiseInbegrepen' + index"
                >
                    {{ element.element }}
                </li>
            </ul>
            <br />
        </span>

        <span
            v-if="cruise.niet_inbegrepen && cruise.niet_inbegrepen.length > 0"
        >
            <b>Exclusief:</b>
            <ul class="nofloat paddingleft20 nomargin margintop5">
                <li
                    v-for="(element, index) in cruise.niet_inbegrepen"
                    :key="'CruiseNietInbegrepen' + index"
                >
                    {{ element.element }}
                </li>
            </ul>
            <br />
        </span>

        <b>Optioneel:</b>
        <div>
            Vluchten, Transfers, Drankenpakket, Fooien/Services,
        </div>
    </div>
</template>

<script>
export default {
    name: 'InExclusive.vue',
    computed: {
        cruise: function() {
            return this.$store.state.cruise
        },
    },
}
</script>

<style scoped></style>
